export const HEADER_TOP_BAR_HEIGHT = "66";
export const HEADER_MENU_HEIGHT = "88";
export const HORIZONTAL_PADDING = "10";
export const CONTAINER_TOP_MARGIN = 5;
